import { MiniPopup } from "@/components/MiniPopup";
import {
  ChangeEvent,
  FormEvent,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import styles from "./SharePopup.module.scss";
import { Product } from "@/api/generatedTypes";
import { MainButton } from "@/components/ui-components/MainButton";
import { useMutation } from "@tanstack/react-query";
import { useToastHandlers } from "@/components/toaster";
import { CheckboxField } from "@/components/ui-components/CheckboxField";
import ProductApi from "@/api/ProductsApi";

type IProps = {
  onClose: () => void;
  product: Product;
};

const SharePopup: React.FC<IProps> = ({ onClose, product }) => {
  const { addToast } = useToastHandlers();
  const [mail, setEmail] = useState<string>("");
  const [name, setName] = useState<string>("");

  const shareRequest = async () => {
    return ProductApi.wink({
      name,
      mail,
      slug: product.slug,
    });
  };

  const shareSendRequest = useMutation(shareRequest, {
    onSuccess: () => {
      onClose();
      addToast({
        title: "e-mail успешно отправлен",
        text: "e-mail был успешно отправлен. Спасибо за ваш запрос!",
        variant: "iconMessage",
        delay: 10000,
      });
    },
    onError: () => {
      addToast({
        title: "ошибка при отправке e-mail",
        text: "имя или e-mail некорректны. Пожалуйста, проверьте данные и попробуйте снова.",
        variant: "base",
        delay: 10000,
      });
    },
  });

  useEffect(() => {
    const originalOverflow = document.body.style.overflow;

    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, []);

  const handleSubmit = useCallback((e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    shareSendRequest.mutate();
  }, []);

  const onEmailChange = (e: ChangeEvent<HTMLInputElement>) =>
    setEmail(e.target.value);

  const onNameChange = (e: ChangeEvent<HTMLInputElement>) =>
    setName(e.target.value);

  const image = useMemo(() => product?.slides?.[0]?.url, [product]);

  return (
    <MiniPopup shown dialogClass={styles.dialog} onClose={onClose}>
      <>
        <div className={styles.overlay} onClick={onClose} />
        <div className={styles.container}>
          <div className={styles.imageContainer}>
            <div onClick={onClose} className={styles.suggestModalCloseBtn}>
              <img
                src="/static/img/icons-v6/cross.svg"
                alt="Suggest Modal Close Button"
              />
            </div>
            <img src={image} className={styles.image} />
          </div>
          <div className={styles.contentWrapper}>
            <div className={styles.header}>
              <div className={styles.content}>{product.name}</div>
            </div>
            <form onSubmit={handleSubmit}>
              <div className={styles.inputBlock}>
                <input
                  type="text"
                  className={styles.input}
                  placeholder="ВВЕДИТЕ ИМЯ*"
                  required
                  value={name}
                  onChange={onNameChange}
                  pattern="[A-Za-zА-Яа-яЁё\s]+"
                  title="Имя должно содержать только буквы"
                />
              </div>
              <div className={styles.inputBlock}>
                <input
                  type="email"
                  className={styles.input}
                  placeholder="ВВЕДИТЕ E-MAIL*"
                  required
                  value={mail}
                  onChange={onEmailChange}
                  title="Пожалуйста, введите правильный адрес электронной почты"
                />
                <MainButton
                  disabled={shareSendRequest.isLoading}
                  type="submit"
                  className={styles.button}
                >
                  ОТПРАВИТЬ
                </MainButton>
              </div>
            </form>
            <div className={styles.checkboxBlock}>
              <CheckboxField
                label="Согласен(-на) на обработку персональных данных, ознакомлен(-на) с Политикой конфиденциальности"
                checked={true}
                toggleChecked={() => {}}
                disabled={true}
                className={styles.checkboxField}
              />
            </div>
          </div>
        </div>
      </>
    </MiniPopup>
  );
};

export default SharePopup;
